import { View } from "./View";

export const TextInput = (props: any) => {
  return <View {...props} />;
};
